package app.smartcoding.realrate

import app.smartcoding.realrate.domain.model.AppCheckTokenProvider
import kotlinx.coroutines.await

class WebAppCheckTokenProvider(private val appCheck: AppCheck?) : AppCheckTokenProvider {
    override suspend fun getToken(): String? {
        if (appCheck == null) return null

        return try {
            val response = getToken(appCheck, false).await()
            response.token
        } catch (e: Exception) {
            println("Грешка при извличане на App Check токен: $e")
            null
        }
    }
}